/**
 * Interactive Utils Mode
 * Launch the professional Ink-based TUI
 */
import React from 'react';
import { render } from 'ink';
import { UtilsApp } from '../../ui/utils/UtilsApp.js';

export async function runInteractiveMode(): Promise<void> {
    return new Promise((resolve) => {
        const { unmount, waitUntilExit } = render(
            React.createElement(UtilsApp, {
                onExit: () => {
                    unmount();
                    resolve();
                },
            })
        );

        // Wait for the app to exit
        waitUntilExit().then(() => {
            resolve();
        });
    });
}
